import React from 'react'
import { Menu, Dropdown } from 'antd'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import styles from './style.module.scss'

const flags = {
  en: (
    <img
      src="/resources/images/flags/en-flag-waving-xs.png"
      alt="EN"
      className={styles.languageFlag}
    />
  ), // '🇬🇧' Emoji Flags are not supported by windows
  de: (
    <img
      src="/resources/images/flags/ger-flag-waving-xs.png"
      alt="DE"
      className={styles.languageFlag}
    />
  ), // '🇩🇪'
}

@connect(({ settings }) => ({ settings }))
class LanguageSelector extends React.Component {
  changeLang = ({ key }) => {
    const { dispatch } = this.props
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'locale',
        value: key,
      },
    })
  }

  render() {
    const {
      settings: { locale },
      dropdownPlacement = 'bottomLeft',
    } = this.props
    const language = locale.substr(0, 2)

    const langMenu = (
      <Menu className={styles.menu} selectedKeys={[locale]} onClick={this.changeLang}>
        <Menu.Item key="en-US">
          <span role="img" aria-label="English" className="mr-2">
            {flags.en}
          </span>
          <FormattedMessage id="menu.language.en" />
        </Menu.Item>
        <Menu.Item key="de-DE">
          <span role="img" aria-label="German" className="mr-2">
            {flags.de}
          </span>
          <FormattedMessage id="menu.language.de" />
        </Menu.Item>
        {/* <Menu.Item key="fr-FR">
          <span role="img" aria-label="French" className="mr-2">
            🇫🇷
          </span>
          French
        </Menu.Item>
        <Menu.Item key="ru-RU">
          <span role="img" aria-label="Русский" className="mr-2">
            🇷🇺
          </span>
          Русский
        </Menu.Item>
        <Menu.Item key="zh-CN">
          <span role="img" aria-label="简体中文" className="mr-2">
            🇨🇳
          </span>
          简体中文
        </Menu.Item> */}
      </Menu>
    )
    return (
      <Dropdown overlay={langMenu} trigger={['click']} placement={dropdownPlacement}>
        <div className={styles.dropdown}>
          <strong className="text-uppercase">
            {flags[language]}
            {language}
          </strong>
        </div>
      </Dropdown>
    )
  }
}

export default LanguageSelector
